import BaseComponent from '@js/BaseComponent'

/**
 * Handles special case show/hide behavior of popover element for InfoTags and
 * dynamic width updates
 *
 * @extends BaseComponent
 */
class InfoTag extends BaseComponent {
    constructor(element) {
        super(element)

        this.setLeftInset()

        window.addEventListener('resize', () => {
            this.setLeftInset()
        })

        this.element.addEventListener('blur', () => {
            this.element.popoverTargetElement.hidePopover()
        })

        this.element.popoverTargetElement.addEventListener('toggle', event => {
            if (event.newState === 'open') {
                window.addEventListener('focus', this.closeOnBlur, true);
            } else if (event.newState === 'closed') {
                window.removeEventListener('focus', this.closeOnBlur, true);
            }
        })
    }

    closeOnBlur = (event) => {
        if (event.target !== this.element) {
            this.element.popoverTargetElement.hidePopover()
        }
    }

    setLeftInset = () => {
        const elementLeft = this.element.getBoundingClientRect().left
        const mainLeft = document.querySelector('main').getBoundingClientRect().left

        if (elementLeft < window.innerWidth / 2) {
            this.element.style.setProperty('--modal-inset-left', `${elementLeft - mainLeft}px`)
            this.element.popoverTargetElement.classList.remove('full-width-popover')
        } else {
            this.element.popoverTargetElement.classList.add('full-width-popover')
        }
    }
}

InfoTag.create('button.info-tag')
